import { FC } from 'react'
import { VStack } from '@chakra-ui/react'
import { IAlignment, IPadding, ISectionButton } from 'shared/types'
import SectionWidthSelect from 'components/SectionWidthSelect'
import PaddingSelect from 'components/PaddingSelect'
import SimpleInput from 'shared/components/SimpleInput'
import AlignmentSelect from 'components/AlignmentSelect'

type Props = {
  s: ISectionButton
  onChange: (s: ISectionButton) => void
}

const EditSectionButton: FC<Props> = ({ s, onChange }) => {
  const onChangeSectionWidth = (v: number) => {
    onChange({ ...s, widthCol: v })
  }

  const renderSectionWidth = () => {
    return (
      <SectionWidthSelect value={s.widthCol} onChange={onChangeSectionWidth} />
    )
  }

  const renderPadding = () => {
    return (
      <PaddingSelect
        value={s.paddingTop}
        onChange={(v: IPadding) => onChange({ ...s, paddingTop: v })}
      />
    )
  }

  const renderButtonTitle = () => {
    return (
      <SimpleInput
        label='Текст кнопки'
        value={s.button?.title || ''}
        onChange={(v: string) =>
          onChange({ ...s, button: { ...(s.button || {}), title: v } })
        }
      />
    )
  }

  const renderButtonUrl = () => {
    return (
      <SimpleInput
        label='Ссылка'
        value={s.button?.url || ''}
        onChange={(v: string) =>
          onChange({ ...s, button: { ...(s.button || {}), url: v } })
        }
      />
    )
  }

  const renderButtonAlignment = () => {
    return (
      <AlignmentSelect
        label='Выравнивание'
        value={s.button.alignment}
        onChange={(v: IAlignment) =>
          onChange({ ...s, button: { ...(s.button || {}), alignment: v } })
        }
      />
    )
  }

  return (
    <VStack w='full' spacing={6}>
      {renderSectionWidth()}
      {renderPadding()}
      {renderButtonTitle()}
      {renderButtonUrl()}
      {renderButtonAlignment()}
    </VStack>
  )
}

export default EditSectionButton
